import { tAddress } from "../interfaces/interfaces";

const startsWith0xLen42HexRegex = /^0x[0-9a-fA-F]{40}$/;

export const checkValidAddress = (address: string): tAddress => {
	if (startsWith0xLen42HexRegex.test(address)) {
		return address as tAddress;
	}
	
	throw new Error(`${address} is not a valid address.`);
}